<div *ngIf="!Shitch_LabAddress">
  <label for="exampleInputEmail1">
    <button type="button" (click)="Shitch_LabAddress_click()" class="btn btn-secondary">
      Customer Laboratory (Click to Select)
    </button>
  </label>
  <input [(ngModel)]="inner_Calibration_Lab_Address" (keyup)="set_inner_Calibration_Lab_Address()" name="labAdderss" placeholder="Type here..." type="text" class="form-control">
</div>

<div *ngIf="Shitch_LabAddress">
  <label for="exampleInputEmail1">
    <button type="button" (click)="Shitch_LabAddress_click()" class="btn btn-secondary">
      Customer Laboratory (Click to Type)
    </button>
  </label>
  <select class="custom-select" [(ngModel)]="inner_Calibration_Lab_Address" (change)="set_inner_Calibration_Lab_Address()" name="labAdderss" >
    <option value="">Select</option>
    <option *ngFor="let item of Datalist_LabAddress" [value]="item">{{item}}</option>
  </select>
</div>